import { QuestionSquareFill } from 'styled-icons/bootstrap';
import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryBet from '@/assets/betroyale/images/mysteryBet.png';

export const mysteryBetStyles: MysteryBetSchema = {
  buttonMyBets: {
    fontSize: ['xs', 'sm'],
  },
  tooltipIcon: {
    fill: 'alpha.900',
    boxSize: 5,
  },
  flexWrapperWithTooltip: {
    gap: 2,
  },
  textPriceInfo: {
    color: 'beta.500',
    fontWeight: 'bold',
  },
  textSlash: {
    color: 'whiteAlpha.400',
    fontWeight: 'bold',
  },
  flexRaceInfo: {
    gap: 1,
    fontWeight: 'bold',
    color: 'white',
  },
  iconRace: {
    color: 'alpha.400',
    boxSize: 6,
  },
  textRollover: {
    color: 'beta.500',
    fontWeight: 'bold',
  },
  iconMystery: {
    as: QuestionSquareFill,
  },
  flexWrapperMysteryLabelView: {
    color: 'white',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontWeight: 'bold',
    gap: 1,
    lineHeight: 'normal',
    alignItems: 'center',
  },
  iconBack: {
    boxSize: 6,
    color: 'alpha.400',
  },
  flexWrapperMysteryRolloverView: {
    gap: [1, 2],
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    px: 3,
    color: 'white',
    overflow: 'hidden',
    mx: 'auto',
  },
  buttonRollOver: {
    h: '26px',

    _disabled: {
      bg: 'alpha.900',
      color: 'white',
      border: 'none',
      boxShadow:
        '0px 1px 0px 0px rgba(255, 255, 255, 0.08), 0px 2px 0px 0px rgba(0, 0, 0, 0.30) inset',
      px: 3,
      _hover: { bg: 'none' },
    },
  },
  buttonAddToBetslip: {
    variant: 'secondary',
    px: [2, 2, 3],
    fontSize: ['2xs', 'xs', 'sm'],
    h: 9,
  },
  flexWrapperMysteryBetReviewView: {
    gap: 2,
    p: 2,
  },
  buttonMysteryLabel: {
    variant: 'unstyled',
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    borderRadius: 'md',
    color: 'white',
    sx: {
      '&&': {
        px: [2, 3],
      },
    },
    lineHeight: '15px',
    maxH: 9,
    fontSize: ['2xs', 'xs'],
    fontWeight: 'semibold',
  },
  flexWrapperMysteryTooltipIcon: {
    bgGradient: 'linear(180deg, alpha.500, alpha.600)',
    boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.30)',
    borderRadius: 'md',
    boxSize: 9,
    p: '2',
    color: 'white',
  },
  flexWrapperOdds: {
    gap: 1,
  },
  flexWrapperLogoOdds: {
    gap: 2,
  },
  buttonOdds: {},
  flexWrapperMysteryBetSelectionView: {
    mx: 2,
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'lg',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    p: 2,
  },
  imageLogo: {
    src: `${mysteryBet}`,
    w: ['200px', '234px'],
    pos: 'relative',
  },
};
